import { Injectable } from '@angular/core';
import { Observable, of, delay } from 'rxjs';
import ApiOptionsConfig from '../api-options.config';

@Injectable({
  providedIn: 'root'
})
export class CompanyLocationsService {
private companyLocations = [
    {
      id: 1,
      comapnyLocationId: 1,
      code: 'AR',
      name: "Argentina",
      createTime: '10/01/2023 09:47',
    },
    {
      id: 2,
      companyLocationId: 2,
      code: 'SP',
      name: "Spagna",
      createTime: '19/07/2022 16:38',
    },
    {
      id: 3,
      companyLocationId: 3,
      code: 'IT',
      name: "Italy",
      createTime: '19/07/2022 16:38',
    }
  ]
  constructor() { }


  list(options?: ApiOptionsConfig): Observable<any> {
    const response = {
      status: {
        code: 200,
        description: "OK",
        timestamp: new Date().toISOString(),
        trace: "67ab61fa86fa199e4b87104e49f9e3a0",
        span: "9c9192726658a369"
      },
      data: {
        companyLocations: this.companyLocations
      },
      pagination: {
        page: 0,
        pageSize: 25,
        pageItemCount: 2,
        totalCount: 2,
        totalPages: 1
      }
    };

    return of(response).pipe(delay(500));
  }

  detail(id: number): Observable<any> {
    let companyLocation = this.companyLocations.find(c => c.id === Number(id));

    if (companyLocation) {
      return of({
        status: {
          code: 200,
          description: "OK",
          timestamp: new Date().toISOString()
        },
        data: {
          companyLocations: companyLocation
        }
      }).pipe(delay(500));
    } else {
      return of({
        status: {
          code: 404,
          description: "CompanyLocation Not Found",
          timestamp: new Date().toISOString()
        }
      }).pipe(delay(500));
    }
  }

  create(companyLocation: { id: number; comapnyLocationId:number ,code: string; name: string; createTime: string }): Observable<any> {
    this.companyLocations.push(companyLocation);
    return of({
      status: {
        code: 201,
        description: "CompanyLocation Created",
        timestamp: new Date().toISOString()
      },
      data: {
        companyLocation: companyLocation
      }
    }).pipe(delay(500));
  }

  update(id: number, updatedCompanyLocation: { code?: string; name?: string; createTime?: string }): Observable<any> {
    let companyLocation = this.companyLocations.find(c => c.id === id);

    if (companyLocation) {
      Object.assign(companyLocation, updatedCompanyLocation);
      return of({
        status: {
          code: 200,
          description: "CompanyLocation Updated",
          timestamp: new Date().toISOString()
        },
        data: {
          companyLocation: companyLocation
        }
      }).pipe(delay(500));
    } else {
      return of({
        status: {
          code: 404,
          description: "CompanyLocation Not Found",
          timestamp: new Date().toISOString()
        }
      }).pipe(delay(500));
    }
  }
}
